(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["agenti-directory"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initializeDirectory(root) {
      var input = root.querySelector('[data-directory-input]');
      var rows = Array.prototype.slice.call(root.querySelectorAll('[data-directory-search]'));
      var groups = Array.prototype.slice.call(root.querySelectorAll('.directory-group'));
      var empty = root.querySelector('[data-directory-empty]');

      if (!input || !empty) return;

      input.addEventListener('input', function () {
        var query = input.value.trim().toLowerCase();
        var visible = 0;

        rows.forEach(function (row) {
          var searchableText = row.getAttribute('data-directory-search').toLowerCase();
          var match = !query || searchableText.indexOf(query) !== -1;
          row.hidden = !match;
          if (match) visible += 1;
        });

        groups.forEach(function (group) {
          var groupRows = Array.prototype.slice.call(group.querySelectorAll('[data-directory-search]'));
          var hasMatch = groupRows.some(function (row) {
            return !row.hidden;
          });
          group.hidden = !hasMatch;
          if (query && hasMatch) group.open = true;
        });

        empty.hidden = visible > 0;
        empty.style.display = visible > 0 ? 'none' : 'block';
      });
    }

    Array.prototype.forEach.call(document.querySelectorAll('[data-directory]'), initializeDirectory);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clienti-directory"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initializeDirectory(root) {
      var input = root.querySelector('[data-directory-input]');
      var rows = Array.prototype.slice.call(root.querySelectorAll('[data-directory-search]'));
      var groups = Array.prototype.slice.call(root.querySelectorAll('.directory-group'));
      var empty = root.querySelector('[data-directory-empty]');

      if (!input || !empty) return;

      if (root.classList.contains('directory--clients')) {
        groups.forEach(function (group) {
          var sortHeader = group.querySelector('thead th:nth-child(2)');
          var tableBody = group.querySelector('tbody');

          if (!sortHeader || !tableBody || sortHeader.querySelector('[data-directory-sort]')) return;

          var sortButton = document.createElement('button');
          sortButton.className = 'directory-table__sort';
          sortButton.type = 'button';
          sortButton.setAttribute('data-directory-sort', 'ascending');
          sortButton.setAttribute('aria-label', 'Ordinamento per Provincia e Città: crescente');
          sortButton.innerHTML = '<span>Provincia - Città</span><span class="directory-table__sort-icon" aria-hidden="true">↑</span>';
          sortHeader.textContent = '';
          sortHeader.setAttribute('aria-sort', 'ascending');
          sortHeader.appendChild(sortButton);

          function sortRows(direction) {
            var groupRows = Array.prototype.slice.call(tableBody.querySelectorAll('[data-directory-search]'));
            groupRows.sort(function (firstRow, secondRow) {
              var firstValue = firstRow.querySelector('td[data-label="Provincia - Città"]');
              var secondValue = secondRow.querySelector('td[data-label="Provincia - Città"]');
              var result = (firstValue ? firstValue.textContent.trim() : '').localeCompare(
                secondValue ? secondValue.textContent.trim() : '',
                'it',
                { sensitivity: 'base', numeric: true }
              );
              return direction === 'ascending' ? result : -result;
            });
            groupRows.forEach(function (row) {
              tableBody.appendChild(row);
            });
          }

          sortRows('ascending');

          sortButton.addEventListener('click', function () {
            var nextDirection = sortButton.getAttribute('data-directory-sort') === 'ascending' ? 'descending' : 'ascending';
            sortRows(nextDirection);
            sortButton.setAttribute('data-directory-sort', nextDirection);
            sortButton.setAttribute('aria-label', 'Ordinamento per Provincia e Città: ' + (nextDirection === 'ascending' ? 'crescente' : 'decrescente'));
            sortHeader.setAttribute('aria-sort', nextDirection);
            sortButton.querySelector('.directory-table__sort-icon').textContent = nextDirection === 'ascending' ? '↑' : '↓';
          });
        });
      }

      input.addEventListener('input', function () {
        var query = input.value.trim().toLowerCase();
        var visible = 0;

        rows.forEach(function (row) {
          var searchableText = row.getAttribute('data-directory-search').toLowerCase();
          var match = !query || searchableText.indexOf(query) !== -1;
          row.hidden = !match;
          if (match) visible += 1;
        });

        groups.forEach(function (group) {
          var groupRows = Array.prototype.slice.call(group.querySelectorAll('[data-directory-search]'));
          var hasMatch = groupRows.some(function (row) {
            return !row.hidden;
          });
          group.hidden = !hasMatch;
          if (query && hasMatch) group.open = true;
        });

        empty.hidden = visible > 0;
        empty.style.display = visible > 0 ? 'none' : 'block';
      });
    }

    Array.prototype.forEach.call(document.querySelectorAll('[data-directory]'), initializeDirectory);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hero-audio-control')) {
    customElements.define('hero-audio-control', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const { signal } = this.controller;
        this.button = this.querySelector('button');
        this.videos = [...this.closest('.hero__container').querySelectorAll('video')];
        this.update = () => {
          const visible = this.videos.find((video) => video.getClientRects().length > 0);
          if (visible !== this.activeVideo) {
            this.videos.forEach((video) => { video.muted = true; });
            this.activeVideo = visible;
          }
          this.button.hidden = !visible;
          const audioEnabled = Boolean(visible && !visible.muted);
          this.button.setAttribute('aria-pressed', String(audioEnabled));
          this.button.textContent = audioEnabled ? this.button.dataset.disableLabel : this.button.dataset.enableLabel;
        };
        this.button.addEventListener('click', () => {
          this.update();
          if (this.activeVideo) this.activeVideo.muted = !this.activeVideo.muted;
          this.update();
        }, { signal });
        this.videos.forEach((video) => video.addEventListener('volumechange', this.update, { signal }));
        window.addEventListener('resize', this.update, { signal });
        this.update();
      }

      disconnectedCallback() {
        this.controller.abort();
        this.videos.forEach((video) => { video.muted = true; });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
